import React, {useEffect, useState} from 'react';
import {
  GetStaticProps, GetStaticPropsResult,
  NextPage,
} from 'next';
import {CommonServerSideParams} from '@/app/types/CommonServerSideParams';
import {OnlyBrowserPageProps} from '@/layouts/web/types/OnlyBrowserPageProps';
import {SSGPageProps} from '@/layouts/web/types/SSGPageProps';
import {StaticPropsInput} from '@/app/types/StaticPropsInput';
import {
  getWebLayoutStaticProps,
} from '@/layouts/web/webLayoutSSG';
import WebLayout from '@/layouts/web/components/WebLayout';
import {getReactDivApiConfig} from '@/modules/core/reactDivAPI/utils/getApiConfig';
import deepmerge from 'deepmerge';
import PageHeader from "@/components/centralbrisbanedental/page/Header/Header";
import Annoucement from "@/components/centralbrisbanedental/Announcement";
import Topbar from "@/components/centralbrisbanedental/Topbar";
import NavBar from "@/components/centralbrisbanedental/NavBar/NavBar";
import CTABannerImageDescriptive
  from "@/components/centralbrisbanedental/CTABannerImageDescriptive/CTABannerImageDescriptive";
import CTABannerSplitTiles from "@/components/centralbrisbanedental/CTABannerSplitTiles/CTABannerSplitTiles";
import TwoColumnContent from "@/components/centralbrisbanedental/TwoColumnContent/TwoColumnContent";
import Footer from "@/components/centralbrisbanedental/Footer/Footer";
import {createLogger} from '@/modules/core/logging/logger';


const fileLabel = 'pages/index';
const logger = createLogger({ // eslint-disable-line no-unused-vars,@typescript-eslint/no-unused-vars
  fileLabel,
});

let drVincentContentA: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: '<span>BDSc (Hons) (Qld)</span><br /> ' +
              'The Brisbane CBD has been part of Dr' +
              'Vincent Wan’s life since he was 4 years old.  Born in Hong Kong when it was still a British territory, Vincent’s family moved to Brisbane in 1985.  He went to primary school at Warrigal Road State School in Eight Mile Plains, before transferring to St Peter’s Catholic Primary School in Rochedale during grade 3.  It was at St Peter’s that Vincent became School Vice Captain in grade 7.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            },
            spanClasses: {
              fontWeight: "extrabold",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Vincent remembers fondly catching the bus ' +
              'on the weekend with his family and friends into the Brisbane CBD.  At that time, the top level of the Myer Centre was a fun park called Tops with a dragon roller coaster, swinging pirate ship and a mini ferris wheel.  World Expo 88 was another memorable childhood destination with all the international pavilions and the monorail that ran along the Brisbane River where it is now the South Bank Parklands.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            },
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/dr-vincent-wan.png.webp',
              height: 304,
              width: 214,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]
let drVincentContentB: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Vincent went to high school at Brisbane ' +
              'Grammar School on Spring Hill right next to the Brisbane CBD, achieving the school’s award for academic excellence each of the 5 years he was there.  He received his Bachelor of Dental Science degree with First Class Honours from the University of Queensland in 2003.  His training was completed at the university’s Dental School located on Turbot Street in the Brisbane CBD.  Vincent was hand-picked by one of his university lecturers, Dr Michael Mandikos, to join his Brisbane CBD dental practice, First Dental Studio (then known as Adelaide and Albert St Dental Centre), upon graduation.  He was well received by patients and became partner at First Dental Studio in 2005.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            },
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Many Brisbane CBD dentists supported ' +
              'Vincent in growing his practice, referring extra patients as well as their own patients to him when they did not have appointments to see them or were away on holidays.  One of the dentists, Dr Michael O’Brien, formed such a close relationship with Vincent that he invited him to take over his practice when he was thinking of retiring.  After working closely together, Vincent bought Central Brisbane Dental from Dr O’Brien in 2008.  Vincent now splits his time between the 2 dental practices, spending Mondays and Thursdays at Central Brisbane Dental and Tuesdays and Wednesdays at First Dental Studio.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            },
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/bat-toothy-dr-vincent-wan.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]
let drVincentContentC: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      margin: "mt-8"
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Vincent loves the Brisbane CBD so much he ' +
              'even lives in an apartment in the city with his lovely wife, Dorothy, and their little boy, Jasper.  Besides looking after Jasper, Dorothy helps Vincent out as Practice Manager of Central Brisbane Dental and First Dental Studio.  Vincent is very active in the dental field, going regularly to continuing education courses to stay up to date with the latest techniques and technologies.  He founded the Infusion Dental Study Club and was their first president and current treasurer.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            },
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Outside of work, Vincent and his family love ' +
              'Lego and pop culture collectibles especially of Star Wars and superheroes like Batman, Superman and the Avengers.  This can be clearly seen at the practices where there are 3D Star Wars displays and mini statues and figures from various popular games, movies and TV shows.  They also collect sneakers, with Vincent usually wearing his signature gold and silver liquid metal edition Nikes or some variation to work.  Activity-wise, they enjoy mini golf and video games that can be played together as a family such as Mario Kart and Just Dance.  Vincent and Dorothy are also self-proclaimed foodies and love to try new restaurants.  If Jasper gives a restaurant the thumbs up, you know it’s a good one given he’s pretty fussy with his food and drink.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            },
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'supertoothy and battoothy fighting decay and germs.',
              src: '/static/images/tiles/dr-vincent-wan-and-dr-allen-wan.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]

/**
 * Only executed on the server side at build time.
 * Necessary when a page has dynamic routes and uses "getStaticProps".
 */
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths({fallback:true});
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths();

/**
 * Only executed on the server side at build time.
 *
 * @return Props (as "SSGPageProps") that will be passed to the Page component, as props.
 *
 * @see https://github.com/vercel/next.js/discussions/10949#discussioncomment-6884
 * @see https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 */
export const getStaticProps: GetStaticProps<SSGPageProps, CommonServerSideParams> = async (props: StaticPropsInput): Promise<GetStaticPropsResult<SSGPageProps>> => {
  const commonStaticProps: GetStaticPropsResult<SSGPageProps> = await getWebLayoutStaticProps()(props);
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('getStaticProps commonStaticProps', commonStaticProps); // eslint-disable-line no-console
  }

  if ('props' in commonStaticProps) {
    const config = getReactDivApiConfig();

    const [
      // Below is Web Module
      // currentShelledPage,
      // currentClientProjectSEOSettings,
      // currentShelledPageSeoSettings, // NOTE This is a dependency, should loop through these
      // currentClientProjectSEOSettings,
      // Above is Web Module
    ] = await Promise.all([
      // Below is Web Module
      // getShelledPageBySingularAPIID({config, slug: 'home'}),
      // getSystemShelledFieldsBySystemShellID({config, systemShellID: '630f756db23725aedbc16e7d'}),
      // getClientProjectContentBySystemShellID({
      //   config,
      //   clientID: commonStaticProps.props.reactDivClientID,
      //   projectID: commonStaticProps.props.reactDivClientProjectID,
      //   systemShellID: '630f756db23725aedbc16e7d',
      // }),
      // getBySingularAPIID({config, slug: "home"}),
      // Above is Web Module
    ]);

    return deepmerge(commonStaticProps, {
      props: {
        // Below is Web Module
        // currentShelledPage,
        // currentShelledPageSeoSettings,
        // currentClientProjectSEOSettings,
        // Above is Web Module
        builtAt: new Date().toISOString(),
      },
      // revalidate: regenerationDelay,
    });
    // return commonStaticProps;
  } else {
    return commonStaticProps;
  }

};
/**
 * SSG pages are first rendered by the server (during static bundling).
 * Then, they're rendered by the client, and gain additional props (defined in OnlyBrowserPageProps).
 * Because this last case is the most common (server bundle only happens during development stage), we consider it a default.
 * To represent this behaviour, we use the native Partial TS keyword to make all OnlyBrowserPageProps optional.
 *
 * Beware props in OnlyBrowserPageProps are not available on the server.
 */
type Props = {} & SSGPageProps<Partial<OnlyBrowserPageProps>>;

/**
 * Example of a public page.
 */
const OurPhilosophy: NextPage<Props> = (props): JSX.Element => {
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('OurPhilosophy: props', props); // eslint-disable-line no-console
  }
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      ;
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <>
      <WebLayout
        // reactDivClientID={}
        // reactDivClientProjectID={}
        hideFooter={false}
        pageSeoSettings={{
          seoTitle: 'Dr Vincent Wan, Local Brisbane Dentist',
          seoDescription: 'Central Brisbane Dental provide affordable dental treatment with regular promotions for new patients, as well as regular patient specials. Brisbane dentist Dr Vincent Wan has over 20 yrs experience. ',
          seoImage: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
          favicon: '/static/images/favicon/favicon-96.png',
        }}
      >
      <PageHeader
        title="Dr Vincent Wan"
        background="bg-[#400068]"
        backgroundImage="/static/images/headers/life-cycle-header-overlay.png"
      />
      <main>
        <TwoColumnContent
          title="General Dentist"
          heading="At Central Brisbane Dental, getting the best outcome for your oral health is our number one priority."
          content={drVincentContentA}
        />
        <CTABannerImageDescriptive
          imageProperties={{
            layout: 'intrinsic',
            alt: 'happy toothy character',
            type: 'dimensions',
            src: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
            height: 285,
            width: 412.5,
          }}
          title="Philips Zoom"
          heading="Teeth Whitening for just $660!"
          description="Come in for a free consultation."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          imageClasses={{
            textAlign: "center",
            padding: "p-5"
          }}
          titleClasses={{
            dynamicColour: '#ff6600',
            fontSize: 'text-base',
            fontWeight: 'semibold',
            letterSpacing: 'tracking-wider',
            uppercase: true,
          }}
          headingClasses={{
            margin: 'mt-2',
            fontSize: 'text-2xl sm:text-3xl',
            fontWeight: 'extrabold',
            letterSpacing: 'tracking-tight',
            colour: 'text-white',
          }}
          descriptionClasses={{
            margin: 'mt-3',
            fontSize: 'text-lg',
            colour: 'text-white'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#070707',
          }}
        />
        <TwoColumnContent
          content={drVincentContentB}
        />
        <CTABannerSplitTiles
          dentist="vincent"
          heading="Did you know?"
          value="You can get 2 checkup and cleans a year for $0 or a very small out-of-pocket when you come and see us and use your health fund."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          hasInset={true}
          insetClasses={{
            display: 'hidden lg:block',
            position: 'absolute top-0 inset-x-0',
            height: 'h-1/2',
            dynamicBackground: '#400068'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#fff',
            padding: 'py-16'
          }}
        />
        <TwoColumnContent
          content={drVincentContentC}
        />
      </main>
      </WebLayout>
    </>
  );
};

export default OurPhilosophy;
